import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { selectCustomerProfile } from '../../../../store/selectors/customerProfile'
import { Chromebot } from '@homebot/listings-bot'
import { getClientToken } from '../../../../auth'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'

export interface ListingsBotProps {
  listing: { priceCents: number; fullAddress: string }
}

const ListingsBot = ({ listing }: ListingsBotProps) => {
  const customer = useSelector(selectCustomerProfile)
  const token = getClientToken()
  const { ampli } = useContext(AmplitudeContext)

  return (
    <Chromebot
      listingPrice={listing.priceCents / 100}
      address={listing.fullAddress}
      clientAuthToken={token}
      customerPublicKey={customer.publicKey}
      customerProfileId={customer.id}
      amplitudeInstance={ampli}
    />
  )
}

export default ListingsBot
